// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"153a0979","787":"381d34b3"}[chunkId] + ".chunk.js";
};